module.exports = __webpack_public_path__ + "static/media/about9.f135f051.webp";